export const ACCEPT_CONFIG = {
    image: ['.png', '.jpg', '.jpeg', '.gif'],
    // video: ['.mp4', '.rmvb', '.mkv', '.wmv', '.flv','.mp3'],
    // document: ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.pdf', '.txt', '.tif', '.tiff','zip'],
    document: ['.pdf'],
    getAll(){
        // return [...this.image, ...this.video, ...this.document]
        return [...this.image, ...this.document]
    },
};


// WEBPACK FOOTER //
// ./src/components/Upload/js/config.js